class HeySmileHomeOffers extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form[action*="/cart/add"]');
    this.radios = [...this.querySelectorAll('[data-hs-home-variant]')];
    this.submit = this.querySelector('[data-hs-home-submit]');
    this.radios.forEach((radio) => radio.addEventListener('change', () => this.select(radio)));
  }

  select(radio) {
    this.radios.forEach((item) => {
      item.closest('[data-hs-home-offer]')?.classList.toggle('is-selected', item === radio);
    });
    if (!this.submit) return;
    this.submit.disabled = radio.dataset.available !== 'true';
    this.submit.textContent = this.submit.disabled ? 'Sold out' : `Add to cart — ${radio.dataset.price}`;
  }
}

if (!customElements.get('hey-smile-home-offers')) {
  customElements.define('hey-smile-home-offers', HeySmileHomeOffers);
}
